import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import styled from 'styled-components';
import SvgIcon from '../SvgIcon';
import { colors } from '../../lib/colors';
import { overlay } from 'overlay-kit';

const modalStack: string[] = [];
let bodyOverflowBackup: string | null = null;

type Props = {
    children: React.ReactNode;
    whiteViewWidth?: number | string;
    whiteViewHeight?: number;
    setIsVisible?: Dispatch<SetStateAction<boolean>>;
    isCloseButton?: boolean;
    isCloseOutside?: boolean;
    onClose?: any;
    borderRadius?: number;
    heightFull?: boolean;
    modalCommpont?: React.ReactNode;
    modalAlign?: 'center' | 'start';
    mt?: number;
    mb?: number;
    isWhiteOverFlowScroll?: boolean;
    backgroundOpacity?: number;
    unmount?: () => void;
};
const Modal = ({
    children,
    whiteViewWidth,
    whiteViewHeight,
    setIsVisible,
    isCloseButton = false,
    isCloseOutside = true,
    onClose,
    borderRadius,
    heightFull,
    modalCommpont,
    modalAlign = 'center',
    mt,
    mb,
    isWhiteOverFlowScroll = true,
    backgroundOpacity = 0.3,
    unmount,
}: Props) => {
    const ref = useRef<HTMLDivElement>(null);
    const modalIdRef = useRef(`modal-${Math.random().toString(36).slice(2, 9)}`);

    const isTopMost = () => modalStack[modalStack.length - 1] === modalIdRef.current;

    const handleClickOutside = (event: MouseEvent) => {
        if (!isTopMost()) return;
        if (ref.current && !ref.current.contains(event.target as Node) && isCloseOutside) {
            // modalCommpont
            //     ? undefined
            //     : onClose
            //     ? onClose()
            //     : setIsVisible && setIsVisible(false);
            if (modalCommpont) {
                return;
            } else if (onClose) {
                onClose();
            } else {
                setIsVisible && setIsVisible(false);
            }
        }
    };

    useEffect(() => {
        const wasEmpty = modalStack.length === 0;
        modalStack.push(modalIdRef.current);
        if (wasEmpty) {
            bodyOverflowBackup = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
        }
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
        // document.body.style.overflow = 'auto'; // Allow scrolling

        return () => {
            const index = modalStack.lastIndexOf(modalIdRef.current);
            if (index >= 0) {
                modalStack.splice(index, 1);
            }
            if (modalStack.length === 0 && bodyOverflowBackup !== null) {
                document.body.style.overflow = bodyOverflowBackup;
                bodyOverflowBackup = null;
            }
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            if (!isTopMost()) return;
            onClose && onClose();
            setIsVisible && setIsVisible(false);
        }
    };
    // const handleBackgroundScroll = (event: React.WheelEvent<HTMLDivElement>) => {
    //     // 모달 외부 스크롤 시 id="App"에 스크롤 이벤트 적용
    //     if (event.target === event.currentTarget) {
    //         const appElement = document.getElementById('App');
    //         if (appElement) {
    //             appElement.scrollTop += event.deltaY;
    //         }
    //     }
    // };
    return (
        <div
            className={`fixed  w-full h-full bg-black flex overflow-y-auto   ${
                modalAlign === 'center' ? 'justify-center items-start top-0 left-0 ' : ' justify-center items-start'
            }

            `}
            // onWheel={handleBackgroundScroll} // 배경 스크롤 이벤트 추가
            style={{
                zIndex: 2000,
                backgroundColor: `rgba(0, 0, 0, ${backgroundOpacity})`,
            }}
        >
            <div
                ref={ref}
                style={{
                    width: whiteViewWidth,
                    height: isWhiteOverFlowScroll ? whiteViewHeight : 'auto', // isWhiteOverFlowScroll false일때 내용만큼 늘어나도록 수정
                    position: 'relative',
                    borderRadius: borderRadius || 8,
                    boxShadow: '8px 8px 24px 0px #00000052',
                    marginTop: mt,
                    marginBottom: mb,
                }}
                className={` ${heightFull ? 'h-full' : ''}  bg-white rounded-[8px]
                ${modalAlign === 'center' ? 'my-auto' : 'mt-[60px]'}
                ${isWhiteOverFlowScroll ? 'overflow-y-auto' : 'overflow-visible'}
                `}
            >
                {isCloseButton && (
                    <SvgIcon
                        className=" absolute right-[27px] top-[27px]  cursor-pointer"
                        style={{ zIndex: 20 }}
                        name={'SvgX'}
                        stroke={'#A5ABB5'}
                        size={40}
                        onClick={onClose ? onClose : () => setIsVisible && setIsVisible(false)}
                    />
                )}

                {children}
            </div>
            {modalCommpont && modalCommpont}
        </div>
    );
};

export default Modal;
